import { Component, OnInit } from '@angular/core';
import { ISessionService } from '@insight/services';
import { Router, RouterStateSnapshot } from '@angular/router';

@Component({
	selector: 'app-app-default',
	template: '',
	styles: []
})
export class AppDefaultComponent implements OnInit {

	constructor(
		private sessionService: ISessionService,
		private router: Router
	) {

	}

	ngOnInit() {
		const snapshot: RouterStateSnapshot = this.router.routerState.snapshot;
		if (this.sessionService.isAuth()) {
			const user = this.sessionService.getUser();
			this.router.navigate([user.defaultRoute || '/backend']);
		} else {
			this.router.navigate(['/siteplan']);
		}
	}

}
